export default __webpack_public_path__ + "static/media/bannerDAD.7527cafa.jpg";